import type { WaveEventConfig } from './WaveEventConfig';

export const WOLF_WAVE_CONFIG: WaveEventConfig = {
  id: 'wolf_wave',
  displayName: 'Волна Волков',
  bossType: 'wave_event',

  enemyId: 'wolf',
  enemyCount: 25,
  spawnIntervalMs: 90,

  introText: 'ВОЛНА: ВОЛКИ',
  victoryText: 'ВОЛНА ОТРАЖЕНА',
};
